import GetBooleanFromEnv from 'src/helpers';

const urlBackendAPI:string = process.env.REACT_APP_BACKEND_URL!;

export const appConfig = {
    apps: {
        stella: process.env.REACT_APP_STELLA_URL!,
        firmVersion: process.env.REACT_APP_SOLAR4G_CAMERA_FIRMWARE_LATEST_VERSION!,
        firmTesting: process.env.REACT_APP_SOLAR4G_CAMERA_FIRMWARE_TESTING!,
    },
    gateway: {
        backendURL: urlBackendAPI,
        v2ApiUrl: urlBackendAPI.replace(/\/$/, '') + '/v2',
        blobURL: urlBackendAPI + '/',
        cameraInstalledPhotoBlobURL: urlBackendAPI + '/camera-installed-photo/',
        cameraTaskAttachmentBlobURL: urlBackendAPI + '/camera-task-attachment/',
        cameraViewBlobURL: urlBackendAPI + '/camera-view/',
    },
    flagFeatures: {
        multiLanguage: GetBooleanFromEnv(process.env.REACT_APP_MULTI_LANGUAGE!),
    },
    report: {
        powerBIReportId: process.env.REACT_APP_POWER_BI_REPORT_ID || '',
        powerBIReportHeatMapId: process.env.REACT_APP_POWER_BI_REPORT_HEAT_MAP_ID || '',
    },
    apiGoogle: {
        googleMapApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY || '',
    },
    blobFiles: {
        logFilesUrl: process.env.REACT_APP_FILES_BLOB_URL || '',
    },
    metabase: {
        zoneDashboardId: process.env.REACT_APP_ZONE_DASHBOARD_ID || '',
    },
    contraventionReasonId: {
        EVCars: process.env.REACT_APP_CONTRAVENTION_REASON_ID_EV_CARS!,
        noRoadway: process.env.REACT_APP_CONTRAVENTION_REASON_ID_NO_ROADWAY!,
        cancellationReasonEVCars: process.env.REACT_APP_CANCELLATION_REASON_EV_CARS! || 'Electric vehicle correctly parked in an EV bay',
        cancellationReasonMultipleOffender: process.env.REACT_APP_CANCELLATION_REASON_MULTIPLE_OFFENDER! || 'Multi Offender',
    },
    timeZone: process.env.REACT_APP_TIMEZONE || 'Europe/London',
};
